import { QueryClient } from '@tanstack/react-query';
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30000,
      gcTime: 5 * 60000,
      refetchOnWindowFocus: true,
      structuralSharing: true,
    },
  },
});
